<template>
  <div id="all_rule">
    <div class="all_header_search">
      <a-form :form="form">
        <a-row :gutter="24" type="flex" align="middle">
          <a-col :span="5">
            <a-form-item :label="$t('roleGe.RuleType')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                allowClear
                v-decorator="['ruleType']"
              >
                <a-select-option value="So">So</a-select-option>
                <a-select-option value="InvBal">InvBal</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item :label="$t('roleGe.RuleName')" v-bind="formItemLayout">
              <a-input
                :placeholder="$t('roleGe.RuleName')"
                style="width: 100%;"
                size="small"
                v-decorator="['ruleName']"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item :label="$t('roleGe.Organization')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-model="orgSetVal"
                allowClear
              >
                <a-select-option
                  v-for="item in orgSetList"
                  :value="item.orgCode"
                  >{{ item.displayName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item :label="$t('roleGe.Project')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                :placeholder="$t('publicLang.PleaseSelect')"
                allowClear
                size="small"
                @dropdownVisibleChange="($event) =>{$event ? PoejectDropChange() : null }"
                v-decorator="['projectCode']"
                >>
                <a-select-option
                  v-for="item in ruleProjectList"
                  :value="item.projectCode"
                  >{{ item.displayName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-button type="primary" size="small" @click="searchRule">{{$t('roleGe.Search')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <hr />
    <div>
      <a-row type="flex" justify="space-between">
        <a-row style="margin-bottom: 4px;">
          <a-tooltip placement="topLeft" style="margin-left: 8px;">
            <template slot="title">
              <span>{{ $t('roleGe.Add') }}</span>
            </template>
            <img @click="addRule" class="sbxs" src="../../assets/img/ss-add.png"  width="22" height="22">
          </a-tooltip>
          <a-popconfirm
            :title="$t('pubGicSet.AreyoudeleTask')"
            :okText="$t('pubGicSet.Yes')"
            :cancelText="$t('pubGicSet.No')"
            @confirm="ruleDeleList"
          >
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('roleGe.Delete') }}</span>
              </template>
              <img  style='margin: 0 4px' class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
            </a-tooltip>
          </a-popconfirm>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('roleGe.Edit') }}</span>
            </template>
            <img @click="addRule('edit')" class="sbxs" src="../../assets/img/ss-edit.png"  width="22" height="22">
          </a-tooltip>
        </a-row>
        <a-row>
          <a-pagination
            size="small"
            :total="pagination.pagingTotal"
            v-model="pagination.currentVal"
            :pageSize.sync="pagination.pagingSize"
            @change="orgTableChangePage"
            @showSizeChange="orgShowSizeChange"
            showSizeChanger

          />
        </a-row>
      </a-row>
      <vxe-table
        ref="ruleTableRefs"
        size="mini"
        border
        class="vxe-table-antd"
        :loading="ruleLoading"
        :data.sync="tableData"
      >
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="ruleName" :title="$t('roleGe.RuleName')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="ruleType" :title="$t('roleGe.RuleType')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="orgDisplayName" :title="$t('roleGe.Organization')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="projDisplayName" :title="$t('roleGe.Project')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="creator" :title="$t('roleGe.Creator')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="creatorTime" :title="$t('roleGe.CreateTime')">
          <template v-slot="{ row }">
            <span>{{ row.creatorTime | timeFilter }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifier" :title="$t('roleGe.Modifier')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifyTime" :title="$t('roleGe.ModifiyTime')">
          <template v-slot="{ row }">
            <span>{{ row.modifyTime | timeFilter }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!--config Rule -->
    <a-modal :title="$t('roleGe.Rule')" width="35%" v-model="ruleVisible">
      <template slot="footer">
        <a-button type="primary" size="small" @click="saveRuleHeader">{{ $t('roleGe.Next') }} ></a-button>
      </template>
      <div>
        <a-form :form="configRuleform">
          <a-form-item :label="$t('roleGe.RuleType')" v-bind="formItemLayout">
            <a-select
              style="width: 100%"
              size="small"
              :placeholder="$t('publicLang.PleaseSelect')"
              allowClear
              v-decorator="[
                'ruleType',
                {
                  initialValue: editJsonList.ruleType,
                  rules: [{ required: true, message: $t('publicLang.Required') }]
                }
              ]"
            >
              <a-select-option value="So">So</a-select-option>
              <a-select-option value="InvBal">InvBal</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('roleGe.RuleName')" v-bind="formItemLayout">
            <a-input
              :placeholder="$t('roleGe.RuleName')"
              autocomplete="off"
              style="width: 100%;"
              size="small"
              v-decorator="[
                'ruleName',
                {
                  initialValue: editJsonList.ruleName,
                  rules: [{ required: true, message: $t('publicLang.Required') }]
                }
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('roleGe.Organization')" v-bind="formItemLayout">
            <a-select
              style="width: 100%"
              size="small"
              :placeholder="$t('publicLang.PleaseSelect')"
              v-model="configorgSetVal"
              allowClear
            >
              <a-select-option
                v-for="item in orgSetList"
                :value="item.orgCode"
                >{{ item.displayName }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('roleGe.Project')" v-bind="formItemLayout">
            <a-select
              style="width: 100%"
              :placeholder="$t('publicLang.PleaseSelect')"
              allowClear
              size="small"
            @dropdownVisibleChange="($event) =>{$event ? PoejectDropChange() : null }"
              v-decorator="[
                'projectCode',
                { initialValue: editJsonList.projectCode }
              ]"
            >
              <a-select-option
                v-for="item in EditruleProjectList"
                :value="item.projectCode"
                >{{ item.displayName }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <!--Inventory SO table 列表-->
    <a-modal :title="$t('roleGe.Inventory')" width="70%" v-model="inventoryVisible">
      <template slot="footer">
        <a-button type="primary" size="small" @click="sortSubmit">{{ $t('roleGe.SortSubmit') }}</a-button>
      </template>
      <a-tabs v-model="defaultActiveKey" @change="tabsChangeRule">
        <a-tab-pane :tab="$t('roleGe.Inventory')" key="1">
          <a-row style="margin: 10px 0">
            <a-tooltip placement="topLeft" style="margin-left: 8px;">
              <template slot="title">
                <span>{{ $t('roleGe.Add') }}</span>
              </template>
              <img  @click="editAddInventoryType('add')" class="sbxs" src="../../assets/img/ss-add.png"  width="22" height="22">
            </a-tooltip>
            <a-popconfirm
              :title="$t('pubGicSet.AreyoudeleTask')"
              :okText="$t('pubGicSet.Yes')"
              :cancelText="$t('pubGicSet.No')"
              @confirm="deleteInventory"
            >
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('roleGe.Delete') }}</span>
                </template>
                <img style='margin: 0 4px' class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
              </a-tooltip>
            </a-popconfirm>
          </a-row>
          <div id="all_rule_drop">
            <vxe-table
              ref="InventoryTable"
              border
              row-key="uid"
              size="small"
              resizable
              class="sortable-row-demo vxe-table-antd"
              :loading="Inventoryloading"
              :data.sync="invBalRuleList"
            >
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                type="checkbox"
                width="60"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="tableName"
                :label="$t('roleGe.TableName')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="fieldName"
                :label="$t('roleGe.FieldName')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="inventoryFieldName"
                :label="$t('roleGe.InventoryFieldName')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="fieldType"
                :label="$t('roleGe.FieldType')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="condition"
                :label="$t('roleGe.Condition')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="customizeValue"
                :label="$t('roleGe.CustomizeValue')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="orderBy"
                :label="$t('roleGe.OrderBy')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                :label="$t('roleGe.Operation')"
              >
                <template v-slot="{ row }">
                  <img @click="editAddInventoryType('edit', row)" class="sbxs" src="../../assets/img/ss-edit.png"  width="22" height="22">
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('roleGe.SO')" key="2" forceRender>
          <a-row style="margin: 10px 0">
            <a-tooltip placement="topLeft" style="margin-left: 8px;">
              <template slot="title">
                <span>{{ $t('roleGe.Add') }}</span>
              </template>
              <img @click="addEditSoRule('add')" class="sbxs" src="../../assets/img/ss-add.png"  width="22" height="22">
            </a-tooltip>
            <a-popconfirm
              :title="$t('pubGicSet.AreyoudeleTask')"
              :okText="$t('pubGicSet.Yes')"
              :cancelText="$t('pubGicSet.No')"
              @confirm="soDeleteTable"
            >
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('roleGe.Delete') }}</span>
                </template>
                <img style="margin: 0 4px" class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
              </a-tooltip>
            </a-popconfirm>
          </a-row>
          <div id="soRule">
            <vxe-table
              ref="soRuleTable"
              row-key="uid"
              border
              size="snall"
              resizable
              :loading="soLoading"
              class="sortable-row-demo vxe-table-antd"
              :data.sync="soRuleList"
            >
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                type="checkbox"
                width="60"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="tableName"
                :label="$t('roleGe.TableName')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="fieldName"
                :label="$t('roleGe.FieldName')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="orderBy"
                :label="$t('roleGe.OrderBy')"
              ></vxe-table-column>
              <vxe-table-column
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                :label="$t('roleGe.Operation')"
              >
                <template v-slot="{ row }">
                  <img  @click="addEditSoRule('edit', row)" class="sbxs" src="../../assets/img/ss-edit.png"  width="22" height="22">
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <!--Inventory 编辑新增  -->
    <a-modal :title="$t('roleGe.Inventory')" width="50%" v-model="InventoryEditAddVis">
      <template slot="footer">
        <a-button type="primary" size="small" @click="submitInventory">{{$t('roleGe.Save')}}</a-button>
      </template>
      <a-form :form="InventoryForm">
        <a-row :span="24">
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.TableName')" v-bind="formItemLayout">
              <!--inventoryEditData-->
              <a-select
                style="width: 100%"
                @change="invenTabNameChange"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'tableName',
                  { initialValue: inventoryEditData.tableName }
                ]"
              >
                <a-select-option
                  v-for="item in inventorySelectArr.tinveTableName"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.FieldName')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'fieldName',
                  { initialValue: inventoryEditData.fieldName }
                ]"
              >
                <a-select-option
                  v-for="item in inventorySelectArr.inveFieldName"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.InventoryFieldName')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'invFieldName',
                  { initialValue: inventoryEditData.inventoryFieldName }
                  ]"
                >
                <a-select-option
                  v-for="item in inventorySelectArr.inventoryFieldNameArr"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.FieldType')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'fieldType',
                  {
                    initialValue: inventoryEditData.fieldType,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              >
                <a-select-option value="GP">Grouping</a-select-option>
                <a-select-option value="OD">Order By</a-select-option>
                <a-select-option value="GPOD">Grouping and Order By</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.Condition')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'condition',
                  { initialValue: inventoryEditData.condition }
                ]"
              >
                <a-select-option
                  v-for="item in inventorySelectArr.invenCondition"
                  :value="item.dataValue"
                  >{{ item.dataValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.CustomizeValue')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('roleGe.CustomizeValue')"
                v-decorator="[
                  'fieldValue',
                  { initialValue: inventoryEditData.customizeValue }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.OrderBy')" v-bind="formItemLayout">
              <a-switch
                size="small"
                checkedChildren="asc"
                unCheckedChildren="desc"
                v-decorator="[
                  'orderBy',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      inventoryEditData.orderBy == 'asc' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--so编辑新增-->
    <a-modal title="SO" width="50%" v-model="SOEditAddVis">
      <template slot="footer">
        <a-button type="primary" size="small" @click="SOSubmit">{{ $t('roleGe.Save') }}</a-button>
      </template>
      <a-form :form="SOForm">
        <a-row :span="24">
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.TableName')" v-bind="formItemLayout">
              <!--SOEditData-->
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                @change="SOTabNameChange"
                v-decorator="[
                  'tableName',
                  { initialValue: SOEditData.tableName }
                ]"
              >
                <a-select-option
                  v-for="item in soSelectArr.soTableName"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.FieldName')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'fieldName',
                  { initialValue: SOEditData.fieldName }
                ]"
              >
                <a-select-option
                  v-for="item in soSelectArr.SOFieldName"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('roleGe.OrderBy')" v-bind="formItemLayout">
              <a-switch
                size="small"
                checkedChildren="asc"
                unCheckedChildren="desc"
                v-decorator="[
                  'orderBy',
                  {
                    valuePropPropName: 'checked',
                    initialValue: SOEditData.orderBy == 'asc' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import moment from "moment";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      defaultActiveKey: "1",
      SOEditAddVis: false,
      form: this.$form.createForm(this),
      SOForm: this.$form.createForm(this),
      configRuleform: this.$form.createForm(this),
      InventoryForm: this.$form.createForm(this),
      tableData: [], // header table data
      formItemLayout: {
        // label宽度设置
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      orgSetList: [], // org 下拉数据
      ruleProjectList: [], // project 下拉数据
      EditruleProjectList: [], // 编辑project 的下拉数据
      orgSetVal: undefined,
      configorgSetVal: undefined,
      pagination: {
        pagingTotal: 0,
        currentVal: 1,
        pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30')
      },
      searchObj: "", // header search 条件
      editJsonList: "", // 编辑的json
      addEditType: "", // 当前编辑add 标识
      ruleVisible: false, // 弹窗flag
      inventoryVisible: false, // 弹窗flag
      invBalRuleList: [], // 编辑table data
      soRuleList: [], // 编辑table data
      inventorySelectArr: {
        tinveTableName: [],
        inveFieldName: [],
        inventoryFieldNameArr: [],
        invenCondition: []
      },
      soSelectArr: {
        soTableName: [],
        SOFieldName: []
      },
      RuleHeaderID: "", // id 类别
      InventoryEditAddVis: false,
      Inventoryloading: true,
      soLoading: true,
      ruleLoading: true,
      inventoryEditData: {}, // 编辑inventorydata 数据
      SOEditData: {} // 编辑SO 数据
    };
  },
  created() {
    this.initData();
  },
  filters: {
    timeFilter(val) {
      if (val) {
        return moment(val).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return " - ";
      }
    }
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy();
    }
    if (this.sortableSo) {
      this.sortableSo.destroy();
    }
  },
  methods: {
    //        SO table add edit
    addEditSoRule(type, row) {
      this.SOEditData = {};
      this.SOForm.resetFields();
      ajax.get(api.SORULETABLENAME).then(res => {
        this.soSelectArr.soTableName = res.data;
      });
      if (type == "edit") {
        //                编辑
        this.SOEditData = row;
        this.SOTabNameChange(this.SOEditData.tableName);
      }
      this.SOEditAddVis = true;
    },
    SOTabNameChange(val) {
      ajax.get(api.SORULEFIELDNAME, { tableName: val }).then(res => {
        this.soSelectArr.SOFieldName = res.data.commonSchama;
      });
    },
    //        so 删除
    soDeleteTable() {
      this.soLoading = true;
      let updateRecords = this.$refs.soRuleTable.getCheckboxRecords();
      if (updateRecords.length > 0) {
        let paramsArray = [];
        for (let ii in updateRecords) {
          paramsArray.push(updateRecords[ii].uid);
        }
        let params = {
          uid: paramsArray
        };
        ajax.post(api.SODELETERULEDETAIL, { uid: paramsArray }).then(res => {
          if (res.code == 200) {
            ajax
              .get(api.SORULEDETAILID, { uid: this.RuleHeaderID.ruleHeaderUid })
              .then(res => {
                if (res.code == 200) {
                  this.soLoading = false;
                  this.soRuleList = res.data.soRuleList;
                }
              });
          }
        });
      } else {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
      }
    },
    SOSubmit() {
      this.soLoading = true;
      this.SOForm.validateFieldsAndScroll((err, values) => {
        let params = values;
        params.ruleSubUid = this.RuleHeaderID.soRuleUid;
        params.orderBy = params.orderBy ? "asc" : "desc";
        if (this.SOEditData.uid) {
          params.uid = this.SOEditData.uid;
        }
        ajax.post(api.SAVESORULEDETAIL, params).then(res => {
          this.SOEditAddVis = false;
          if (res.code == 200) {
            ajax
              .get(api.SORULEDETAILID, { uid: this.RuleHeaderID.ruleHeaderUid })
              .then(res => {
                if (res.code == 200) {
                  this.soLoading = false;
                  this.soRuleList = res.data.soRuleList;
                }
              });
          }
        });
      });
    },
    //        so 拖拽
    tabsChangeRule(val) {
      if (val == "2") {
        this.$nextTick(() => {
          let xTable1 = this.$refs.soRuleTable;
          this.sortableSo = Sortable.create(
            xTable1.$el.querySelector(".body--wrapper>.vxe-table--body tbody"),
            {
              onEnd: ({ newIndex, oldIndex }) => {
                let currRow = this.soRuleList.splice(oldIndex, 1)[0];
                this.soRuleList.splice(newIndex, 0, currRow);
              }
            }
          );
        });
      }
    },
    //        拖拽inventroy SO
    dropAllRule() {
      this.$nextTick(() => {
        let xTable = this.$refs.InventoryTable;
        this.sortable = Sortable.create(
          xTable.$el.querySelector(".body--wrapper>.vxe-table--body tbody"),
          {
            onEnd: ({ newIndex, oldIndex }) => {
              let currRow = this.invBalRuleList.splice(oldIndex, 1)[0];
              this.invBalRuleList.splice(newIndex, 0, currRow);
            }
          }
        );
      });
    },
    //        inventroy排序提交
    sortSubmit() {
      let paramsArr = [];
      if (this.defaultActiveKey == "2") {
        paramsArr = this.soRuleList;
      } else {
        paramsArr = this.invBalRuleList;
      }
      this.Inventoryloading = true;
      this.soLoading = true;
      ajax.post(api.RULEDETAILSEQ, { ruleDetails: paramsArr }).then(res => {
        if (res.code == 200) {
          ajax
            .get(api.SORULEDETAILID, { uid: this.RuleHeaderID.ruleHeaderUid })
            .then(res => {
              if (res.code == 200) {
                this.invBalRuleList = res.data.invBalRuleList;
                this.soRuleList = res.data.soRuleList;
                this.Inventoryloading = false;
                this.soLoading = false;
              }
            });
        }
      });
    },
    //        删除Inventory
    deleteInventory() {
      let updateRecords = this.$refs.InventoryTable.getCheckboxRecords();
      if (updateRecords.length > 0) {
        let paramsArray = [];
        for (let ii in updateRecords) {
          paramsArray.push(updateRecords[ii].uid);
        }
        let params = {
          uid: paramsArray
        };
        ajax.post(api.SODELETERULEDETAIL, { uid: paramsArray }).then(res => {
          if (res.code == 200) {
            ajax
              .get(api.SORULEDETAILID, { uid: this.RuleHeaderID.ruleHeaderUid })
              .then(res => {
                if (res.code == 200) {
                  this.invBalRuleList = res.data.invBalRuleList;
                  this.soRuleList = res.data.soRuleList;
                  this.Inventoryloading = false;
                }
              });
          }
        });
      } else {
          this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
      }
    },
    moment,
    //        rule 删除
    ruleDeleList() {
      let updateRecords = this.$refs.ruleTableRefs.getCheckboxRecords();
      if (updateRecords.length > 0) {
        let paramsArray = [];
        for (let ii in updateRecords) {
          paramsArray.push(updateRecords[ii].uid);
        }
        let params = {
          uid: paramsArray
        };
        ajax.post(api.SODELETERULEHEADER, { uid: paramsArray }).then(res => {
          if (res.code == 200) {
            this.initData();
          }
        });
      } else {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
      }
    },
    editAddInventoryType(type, row) {
      //            先置空
      this.inventoryEditData = {};
      this.InventoryForm.resetFields();
      this.InventoryEditAddVis = true;
      ajax.get(api.SORULETABLENAME).then(res => {
        this.inventorySelectArr.tinveTableName = res.data;
      });
      ajax.get(api.GETSQLDROPDATA).then(res => {
        let tt = res.data.condition;
        for (let ii in tt) {
          if (tt[ii].dataKey == "LIKE") {
            tt.splice(ii, 1);
          }
          if (tt[ii].dataKey == "BETWEEN") {
            tt.splice(ii, 1);
          }
        }
        this.inventorySelectArr.invenCondition = res.data.condition;
      });
      if (row) {
        //                编辑
        this.inventoryEditData = row;
        this.invenTabNameChange(this.inventoryEditData.tableName);
      }
    },
    //        tableName change 事件获取其他下拉数据
    invenTabNameChange(val) {
      ajax.get(api.SORULEFIELDNAME, { tableName: val }).then(res => {
        this.inventorySelectArr.inveFieldName = res.data.commonSchama;
        this.inventorySelectArr.inventoryFieldNameArr = res.data.invBalSchama;
      });
    },
    //        edit Add inventory 提交
    submitInventory() {
      this.InventoryForm.validateFieldsAndScroll((err, values) => {
        let params = values;
        params.ruleSubUid = this.RuleHeaderID.invbalRuleUid;
        params.orderBy = params.orderBy ? "asc" : "desc";
        //                编辑
        if (this.inventoryEditData.uid) {
          params.uid = this.inventoryEditData.uid;
        }
        ajax.post(api.SAVESORULEDETAIL, params).then(res => {
          if (res.code == 200) {
            this.Inventoryloading = true;
            ajax
              .get(api.SORULEDETAILID, { uid: this.RuleHeaderID.ruleHeaderUid })
              .then(res => {
                this.Inventoryloading = false;
                if (res.code == 200) {
                  this.InventoryEditAddVis = false;
                  this.invBalRuleList = res.data.invBalRuleList;
                  this.soRuleList = res.data.soRuleList;
                  this.Inventoryloading = false;
                }
              });
          }
        });
      });
    },
    //        添加编辑Rule
    addRule(val) {
      this.configRuleform.resetFields();
      this.editJsonList = "";
      this.configorgSetVal = undefined;
      //            置空
      if (val == "edit") {
        let updateRecords = this.$refs.ruleTableRefs.getCheckboxRecords();
        if (updateRecords.length != 1) {
          this.$customMessage.error(this.$t('publicLang.pleaseOneOnly'));
          return;
        } else {
          this.editJsonList = updateRecords[0];
          this.configorgSetVal = this.editJsonList.orgCode;

          let params = {
            orgCode: this.editJsonList.orgCode
          };
          ajax.get(api.RULEPROJECT, params).then(res => {
            this.EditruleProjectList = res.data;
          });
        }
        this.addEditType = "edit";
      } else {
        this.addEditType = "add";
      }
      this.ruleVisible = true;
    },
    //        search
    searchRule() {
      this.form.validateFields((err, val) => {
        this.searchObj = val;
        this.initData();
      });
    },
    //        初始化数据
    initData() {
      this.ruleLoading = true;
      let params = {
        pageNum: this.pagination.currentVal,
        pageSize: this.pagination.pagingSize
      };
      if (this.searchObj != "") {
        params.ruleName = this.searchObj.ruleName;
        params.orgCode = this.orgSetVal;
        params.projectCode = this.searchObj.projectCode;
        params.ruleType = this.searchObj.projectCode;
      }

      ajax.get(api.QUERYRULE, params).then(res => {
        this.ruleLoading = false;
        if (res.code == 200) {
          this.tableData = res.data.content;
          this.pagination.pagingTotal = res.data.totalElements;
        }
      });
      //            org下拉的list
      ajax.get(api.ORGANIAZTION).then(res => {
        this.orgSetList = res.data;
      });
    },
    //        分页
    orgTableChangePage(val) {
      this.pagination.currentVal = val;
      this.initData();
    },
    //        分页
    orgShowSizeChange(current, pageSize) {
      this.pagination.currentVal = current;
      this.pagination.pagingSize = pageSize;
      this.initData();
    },
    //        project 下拉数据
    PoejectDropChange() {
      let params = {
        orgCode: this.orgSetVal
      };
      ajax.get(api.RULEPROJECT, params).then(res => {
        this.ruleProjectList = res.data;
      });
    },
    //        编辑project 下拉数据
    editPoejectDropChange() {
      let params = {
        orgCode: this.configorgSetVal
      };
      ajax.get(api.RULEPROJECT, params).then(res => {
        this.EditruleProjectList = res.data;
      });
    },
    saveRuleHeader() {
      this.configRuleform.validateFields((err, value) => {
        let params = {
          orgCode: this.configorgSetVal,
          projectCode: value.projectCode,
          ruleName: value.ruleName,
          ruleType: value.ruleType
        };
        if (this.addEditType == "edit") {
          params.uid = this.editJsonList.uid;
        }
        ajax.post(api.SAVESORULEHEADER, params).then(res => {
          if (res.code == 200) {
            this.initData();
            this.RuleHeaderID = res.data;
            ajax
              .get(api.SORULEDETAILID, { uid: res.data.ruleHeaderUid })
              .then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('publicLang.DraglistSort'));
                  this.inventoryVisible = true;
                  this.soLoading = false;
                  this.invBalRuleList = res.data.invBalRuleList;
                  this.soRuleList = res.data.soRuleList;
                  this.Inventoryloading = false;
                  this.dropAllRule();
                }
              });
          }
        });
      });
    }
  }
};
</script>
<style lang="less">
#all_rule {
  background: #fff;
  overflow: hidden;
}
</style>
